import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";
export const usePanicAlertIncidentAssignFieldTeam = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/assign/field/team`, {
        data,
        successMessage: "Team has been assigned successfully",
      }),
  });
export const usePanicAlertIncidentSelfAssign = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`panic/alert/incidents/self/assign/${requestId}`, {
        method: "post",
        successMessage: "Self assigned successfully",
      }),
  });

export const usePanicAlertIncidentBulkAssign = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/bulk/assign`, {
        data,
        successMessage: "Bulk assignment successful",
      }),
  });
export const useGetPanicAlertIncidentAllRequests = () =>
  useMutation({
    mutationFn: (data) => client("panic/alert/incidents/all", { data }),
  });

export const useExportPanicAlertIncidentAllRequests = () =>
  useMutation({
    mutationFn: (data) => client(`panic/alert/incidents/export/all`, { data }),
  });

export const useGetPanicAlertIncidentOpenRequests = () =>
  useMutation({
    mutationFn: (data) => client(`panic/alert/incidents/user/open`, { data }),
  });
export const useExportPanicAlertIncidentOpenRequests = () =>
  useMutation({
    mutationFn: (data) => client(`panic/alert/incidents/export/open`, { data }),
  });
export const useGetPanicAlertIncidentAssignedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/user/assigned`, { data }),
  });
export const useExportPanicAlertIncidentAssignedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/export/assigned`, { data }),
  });
export const useGetSelfPanicAlertIncidentRequests = () =>
  useMutation({
    mutationFn: (data) => client("panic/alert/incidents/my/requests", { data }),
  });

export const useGetPanicAlertIncidentClosedRequests = () =>
  useMutation({
    mutationFn: (data) => client("panic/alert/incidents/closed", { data }),
  });

export const useExportPanicAlertIncidentClosedRequests = () =>
  useMutation({
    mutationFn: (data) =>
      client("panic/alert/incidents/export/closed", { data }),
  });

export const useUpdatePanicAlertIncidentStatus = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/update/status`, {
        data,
        successMessage: "Task has been updated successfully",
      }),
  });
export const useAddPanicAlertIncidentNotes = () =>
  useMutation({
    mutationFn: (data) =>
      client(`panic/alert/incidents/add/notes`, {
        data,
        successMessage: "Notes has been added successfully",
      }),
  });
export const useCreatePanicAlertIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/create`, {
        data,
        successMessage: "Ticket had been created successfully",
      }),
  });
export const useSavePanicAlertIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/save`, {
        data,
        successMessage: "Ticket had been saved successfully",
      }),
  });
export const useSubmitPanicAlertIncidentTicket = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/submit`, {
        data,
        successMessage: "Ticket had been saved successfully",
      }),
  });

export const useGetPanicAlertIncidentTicketDetails = () =>
  useMutation({
    mutationFn: (ticketId) =>
      client(`tickets/panic/alert/incidents/ticket/details/${ticketId}`),
  });

export const useGetPanicAlertIncidentDetails = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`panic/alert/incidents/task/details/${requestId}`),
  });
export const useGetPanicAlertJobCards = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`tickets/panic/alert/incidents/job/card/${requestId}`),
  });
export const useGetPanicAlertIncidentTaskDetails = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`tickets/panic/alert/incidents/task/details/${requestId}`),
  });
export const useGetPanicAlertIncidentRequestDetails = () =>
  useMutation({
    mutationFn: (requestId) =>
      client(`panic/alert/incidents/request/details/${requestId}`),
  });

export const useDeletePanicAlertAttachment = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `panic/alert/incidents/delete/attachment/${data.incidentId}/${data.fieldId}`,
        { method: "delete" }
      ),
  });
export const useUpdatePanicAlertTask = () =>
  useMutation({
    mutationFn: (data) =>
      client(`tickets/panic/alert/incidents/edit/task`, {
        data,
        successMessage: "Ticket had been updated successfully",
      }),
  });
